import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { LoadingSpinner } from '../../../components/LoadingContainer';
import { FullMatchFragment } from '../../../generated/graphql';
import { paths } from '../../../paths';
import { Title } from '../../../components/Title';
import { Heading } from '../../../components/Heading';
import { TextLink } from '../../../components/ClickableText';
import { BackLink } from '../../../components/BackLink';

interface Props {
  match: FullMatchFragment;
}

export const MatchReport: React.FC<Props> = ({ match }) => {
  if (!match.matchReportHtml) {
    return <Redirect to={paths.match.home(match.id)} />;
  }
  return (
    <div>
      <p className="mb-4">
        <BackLink to={paths.match.home(match.id)}>Back to match</BackLink>
      </p>
      <Title className="mb-4">Match Report</Title>
      <Heading level={3} className="text-lg mb-6">
        Match vs {match.opponent}
      </Heading>

      <React.Suspense
        fallback={
          <LoadingSpinner className="mx-auto my-4 border-primary-500" />
        }
      >
        <article
          className="prose prose-primary"
          dangerouslySetInnerHTML={{ __html: match.matchReportHtml }}
        />
      </React.Suspense>
      {match.team.isCaptain ? (
        <p className="mt-6 text-sm text-right">
          <TextLink to={paths.match.settings.matchReport(match.id)}>
            Edit
          </TextLink>
        </p>
      ) : null}
    </div>
  );
};
